import React from 'react';
import styles from './RecordCount.module.css';

interface RecordCountProps {
  label?: string;
  count: number | string;
  className?: string;
}

const RecordCount: React.FC<RecordCountProps> = ({ label, count, className }) => (
  <p className={`${styles.recordCount} ${className ?? ''}`}>
    {label ? <strong>{label}</strong> : null}
    {label ? ' ' : null}
    <span>{count}</span>
  </p>
);

export default RecordCount;
